module.exports = __webpack_public_path__ + "static/media/footer-earth-1.f3740206.svg";